import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findShopGoods = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods?`+params,
        method: 'GET'
    })
}

export const addShopGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods`,
        method: 'POST',
        data: data
    })
}

export const editShopGoods = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods`,
        method: 'PUT',
        data: data
    })
}

export const shopGoodsInOut = (ids,params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/${ids}?`+params,
        method: 'PUT'
    })
}

export const delShopGoods = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}